import React from "react";
import styled from "styled-components";

const ExperienceSection = styled.section`
  padding: 4rem 2rem;
  text-align: center;
  background: #f8f9fa;
  scroll-margin-top: 80px; /* Adjust for fixed navbar */
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  color: #333;
  margin-bottom: 0.5rem;
`;

const SubHeader = styled.p`
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 2rem;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  justify-content: center;
  max-width: 900px;
  margin: auto;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 2rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: translateY(-5px);
    background: #f0f2f5;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
`;

const CardTitle = styled.h3`
  font-size: 1.5rem;
  color: #007bff;
  margin-bottom: 1rem;
`;

const SkillList = styled.ul`
  list-style: none;
  padding: 0;
  color: #555;
`;

const SkillItem = styled.li`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  padding: 0.3rem 0;
  &::before {
    content: "✔";
    color: #007bff;
  }
`;

function Experience() {
  return (
    <ExperienceSection id="experience">
      <SectionTitle>My Experience</SectionTitle>
      <SubHeader>The skills I have</SubHeader>
      <GridContainer>
        <Card>
          <CardTitle>Front-End Development</CardTitle>
          <SkillList>
            <SkillItem>React.js</SkillItem>
            <SkillItem>CMS (WordPress)</SkillItem>
            <SkillItem>ShadCN UI</SkillItem>
            <SkillItem>TypeScript</SkillItem>
            <SkillItem>Next.js</SkillItem>
            <SkillItem>TailwindCSS</SkillItem>
            <SkillItem>HTML</SkillItem>
            <SkillItem>CSS</SkillItem>
            <SkillItem>Vue.js</SkillItem>
          </SkillList>
        </Card>
        <Card>
          <CardTitle>Back-End Development</CardTitle>
          <SkillList>
            <SkillItem>Node.js</SkillItem>
            <SkillItem>Express.js</SkillItem>
            <SkillItem>Git</SkillItem>
            <SkillItem>PostgreSQL</SkillItem>
            <SkillItem>Java</SkillItem>
            <SkillItem>SQL</SkillItem>
            <SkillItem>Python</SkillItem>
            <SkillItem>Laravel</SkillItem>
            <SkillItem>MongoDB</SkillItem>
          </SkillList>
        </Card>
      </GridContainer>
    </ExperienceSection>
  );
}

export default Experience;
